
import { Fragment, useState } from 'react';

import {handlerBy, decimalToHourString} from '../Utils';
import SimpleSelect from '../SimpleSelect';
import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField, Button, IconButton, List, ListItem } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { hourOptions} from '../Utils'
import Iconify from '../Iconify';

function getTomorrow() {
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
}

export default function ExceptionalDays({exceptionalDays, setExceptionalDays}) {

  const [day, setDay] = useState(getTomorrow());
  const [month, setMonth] = useState(getTomorrow().getMonth());
  const [year, setYear] = useState(getTomorrow().getFullYear());
  const [morningStart, setMorningStart] = useState(-1) ;
  const [morningEnd, setMorningEnd] = useState(-1);
  const [afternoonStart, setAfternoonStart] = useState(-1) ;
  const [afternoonEnd, setAfternoonEnd] = useState(-1);
  const [isWorkingDay, setIsWorkingDay] = useState(false);
  const [hasTwoIntervals, setHasTwoIntervals] = useState(false);

  
  // const setDayFromStart = (value) => {
  //   // console.log(value.start);
  //   console.log(value);
  //   setDay(value.start);
  // }

  const handleMonthChange = (month, year) => {
    setMonth(month);
    setYear(year);
  }

  const addExceptionalDay = () => {
    let newExceptionalDays = exceptionalDays.slice();
    newExceptionalDays.push({
      day,
      morningStart,
      morningEnd,
      afternoonStart,
      afternoonEnd
    })
    setExceptionalDays(newExceptionalDays);
  }

  const deleteExceptionalDay = (index) => {
    return () => {
      let newExceptionalDays = exceptionalDays.slice();
      newExceptionalDays.splice(index, 1);
      setExceptionalDays(newExceptionalDays);
    }
  }

  const handleIsWorkingDayChange = (event, value) => {
    if(!value) {
      resetIntervalHours(["morning", "afternoon"]);
    }
    let newIsWorkingDay = value;
    let newHasTwoIntervals = hasTwoIntervals;
    if(!value) {
      newHasTwoIntervals = false;
    }
    setIsWorkingDay(newIsWorkingDay);
    setHasTwoIntervals(newHasTwoIntervals);
  }

  const handleHasTwoIntervalsChange = (event, value) => {
    if(!value) {
      resetIntervalHours(["afternoon"]);
    }
    setHasTwoIntervals(value);
  }

  const resetIntervalHours = (intervals) => {
    for (let interval of intervals) {
      if(interval === "morning") {
        setMorningStart(-1);
        setMorningEnd(-1);
      } else if (interval == "afternoon") {
        setAfternoonStart(-1);
        setAfternoonEnd(-1);
      }
    }
  }

  const changeHour = (bound) => {
    return (value) => {
      // console.log(bound, value);
      if (bound === "morningStart") {
        setMorningStart(parseFloat(value));
      } else if (bound === "morningEnd") {
        setMorningEnd(parseFloat(value));        
      } else if (bound === "afternoonStart") {
        setAfternoonStart(parseFloat(value));    
      } else if (bound === "afternoonEnd") {
        setAfternoonEnd(parseFloat(value));        
      };
    }
  }

  let exceptionalDaysAsTimes = exceptionalDays.map(e => e.day.getTime());

  let firstInterval = (<Fragment/>);
  if(isWorkingDay) {
    firstInterval = (
      <>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(morningStart)}
            onChange={handlerBy(changeHour("morningStart"))}
            label="Début"
            options={hourOptions}
          />
        </Grid>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(morningEnd)}
            onChange={handlerBy(changeHour("morningEnd"))}
            label="Fin"
            options={hourOptions}
          />
        </Grid>
      </>
      // <FormLayout.Group condensed>
      //   <HourSelect title="Début" hour={morningStart}
      //       changeHour={changeHour("morningStart")}
      //   />
      //   <HourSelect title="Fin" hour={morningEnd}
      //       changeHour={changeHour("morningEnd")}
      //   />
      // </FormLayout.Group>
    )
  }

  let secondInterval = (<Fragment/>);
  if(hasTwoIntervals) {
    secondInterval = (
      <>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(afternoonStart)}
            onChange={handlerBy(changeHour("afternoonStart"))}
            label="Début"
            options={hourOptions}
          />
        </Grid>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(afternoonEnd)}
            onChange={handlerBy(changeHour("afternoonEnd"))}
            label="Fin"
            options={hourOptions}
          />
        </Grid>
      </>
      // <FormLayout.Group condensed>
      //   <HourSelect title="Début" hour={afternoonStart}
      //       changeHour={changeHour("afternoonStart")}
      //   />
      //   <HourSelect title="Fin" hour={afternoonEnd}
      //       changeHour={changeHour("afternoonEnd")}
      //   />
      // </FormLayout.Group>
    )
  }

  let exceptionalDaysList = (<Fragment/>);
  if (exceptionalDays.length === 0) {
    exceptionalDaysList = (<Typography>Il n'y a pas de jours exceptionnels.</Typography>);
  }
  else {
    // exceptionalDaysList = (<Typography>There are no exceptional days.</Typography>);
    exceptionalDaysList = (
      <List sx={{py : 0}}>
        {exceptionalDays.map((e, index) => {
          let itemString = e.day.toLocaleDateString();
          if(e.morningStart === -1) {
            // itemString += " is not a workday.";
            itemString += " n'est pas un jour travaillé.";
          } else if (e.afternoonStart === -1) {
            // itemString += " has 1 time interval : from " + e.morningStart + " to " + e.morningEnd + ".";
            itemString += " a 1 plage horaire : de " + decimalToHourString(e.morningStart) + " à " + decimalToHourString(e.morningEnd) + ".";
          } else {
            // itemString += " has 2 time intervals : from " + e.morningStart + " to " + e.morningEnd + " and " +
            itemString += " a 2 plages horaires : de " + decimalToHourString(e.morningStart) + " à " + decimalToHourString(e.morningEnd) + " et " +
                // "from " + e.afternoonStart + " to " + e.afternoonEnd + ".";
                "de " + decimalToHourString(e.afternoonStart) + " à " + decimalToHourString(e.afternoonEnd) + ".";
          }
          return (
            <ListItem key={index} disableGutters sx={{py : 0}}>
                <Typography>{itemString}</Typography>
              {/* <Button plain>
                <Icon source={DeleteMinor} color="critical" />
              </Button> */}
                <Box sx={{pr : 2}}/>
                <IconButton onClick={deleteExceptionalDay(index)}>
                  <Iconify icon={"eva:trash-2-outline"}/>
                </IconButton>
                {/* <Button plain icon={DeleteMinor} onClick={deleteExceptionalDay(index)}></Button> */}
            </ListItem>);
        })}
      </List>
    );
  }

  let disableDatesBefore = new Date();
  let disableDatesAfter = new Date();
  disableDatesAfter.setFullYear(disableDatesAfter.getFullYear()+ 10);

  let addDisabled = false;

  if (isWorkingDay && (morningStart === -1 || morningEnd === -1 ||
      morningStart >= morningEnd)) {
    addDisabled = true;
  }
  if (hasTwoIntervals && (afternoonStart === -1 || afternoonEnd === -1 ||
      afternoonStart >= afternoonEnd || morningEnd > afternoonStart)) {
    addDisabled = true;
  }

  if (exceptionalDaysAsTimes.includes(day.getTime())) {
    addDisabled = true;
  }
  // console.log("addDisabled", addDisabled);

  return (
    <>
      <Grid container spacing={4} wrap="wrap">
        <Grid item sm={12} xs={12} >
          <Typography color="textPrimary" variant="h6">
            Jours exceptionnels
          </Typography>
        </Grid>        
        <Grid item sm={12} xs={12} >
          {exceptionalDaysList}
        </Grid>
        <Grid item sm={12} xs={12} >
          <Typography color="textPrimary" variant="h6">
            Ajouter un jour exceptionnel ?
          </Typography>
        </Grid>  
        <Grid item sm={6} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Date desktop"
              inputFormat="dd/MM/yyyy"              
              value={day}
              onChange={setDay}
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item sm={6} xs={12} sx={{ display: 'flex', flexDirection: 'column'}} >
          <FormControlLabel label="Jour travaillé" control={<Checkbox 
            checked={isWorkingDay}
            onChange={handleIsWorkingDayChange}
          />} />
        {/* </Grid>
        <Grid item sm={12} xs={12} > */}
          <FormControlLabel label="Deux plages horaires" disabled={!isWorkingDay} control={<Checkbox 
            checked={hasTwoIntervals}
            onChange={handleHasTwoIntervalsChange}
          />} />
        </Grid>
        {firstInterval}
        {secondInterval}    
        <Grid item sm={12} xs={12}>
          <Button
            disabled={addDisabled}
            onClick={addExceptionalDay}
          >
            Ajouter
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
